export default __webpack_public_path__ + "assets/MyriadPro-Light.f26a077c.svg";